module.exports = {"510183001":"文君街道","510183002":"临邛街道","510183101":"羊安镇","510183102":"牟礼镇","510183103":"桑园镇","510183104":"平乐镇","510183105":"夹关镇","510183106":"火井镇","510183107":"水口镇","510183108":"固驿镇","510183109":"冉义镇","510183110":"回龙镇","510183111":"高埂镇","510183112":"前进镇","510183113":"高何镇","510183115":"临济镇","510183116":"卧龙镇","510183118":"天台山镇","510183120":"宝林镇","510183121":"南宝山镇","510183201":"茶园乡","510183206":"道佐乡","510183212":"大同乡","510183214":"孔明乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510183.json
// module id = 2272
// module chunks = 0